import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	breadcrumbLinkBase: {
		textDecoration: "none",
		color: colors.gray[800],
		"&:hover": {
			textDecoration: "underline"
		},
		fontSize: "12px"
	},
	breadcrumbLinkInactive: {
		color: colors.gray[700]
	}
})

export default useStyles
